module.exports = __webpack_public_path__ + "static/img/add_to_purchase_order.a6e2c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/add_to_purchase_order.png
// module id = 7cgS
// module chunks = 192